<template>
  <div>
    <div class="current-position">
      <img class="app-banner2" src="../assets/img/banner.png" alt="">
      <div class="current-position-text">
        <div class="app-container">
          <div class="current-position-logotext">Psychological Counseling</div>
        </div>
      </div>
    </div>
    <div class="survey-module">
      <div class="justify-between">
        <div class="survey-module-right">
          <div class="survey-module-right-title f-w justify-between">
            <span class="survey-module-right-title-left">{{ detail_obj.title }}</span>
            <span class="survey-module-right-title-right justify-center align-center" @click="$router.go(-1)">返回</span>
          </div>
          <div class="survey-module-right-action">
            <div class="new-detail" v-html="detail_obj.content" v-if="detail_obj.content"></div>
            <el-empty class="survey-module-right-action-empty" v-else description="暂无内容"></el-empty>
          </div>
        </div>
      </div>
    </div>
    <!-- 悬浮查询模块 -->
    <div class="floating-query" v-if="floating_show">
      <div class="floating-query-title justify-between align-center">
        <span>联系电话</span>
        <span class="floating-query-title-x" @click="floating_show = false">关闭</span>
      </div>
      <div class="floating-query-action">
        <div class="floating-query-action-btn justify-center align-center" @click="callPhone(detail_obj.phone)">
          <i class="el-icon-phone-outline"></i>
          {{ detail_obj.phone }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ConsultDetail} from "@/api/index";
export default {
  data(){
    return{ 
      detail_obj:{
        title:'',
        content:'',
        createTime:'',
        phone:''
      },
      floating_show:true,
    }
  },
  created(){
    ConsultDetail({id:this.$route.query.detail_id}).then((res)=>{
      for(let key in this.detail_obj){
        this.detail_obj[key] = res.data[key]
      }
      this.detail_obj.content = this.detail_obj.content.replace(/<img/g, "<img style='max-width:100%;height:auto;'")
      this.detail_obj.content = this.detail_obj.content.replace(/<video/g, "<video style='max-width:100%;height:auto;'")
    })
  },
  methods:{
    callPhone(phoneNum){
      window.location.href = 'tel://' + phoneNum
    }
  }
}
</script>
<style scoped lang="css" src="../assets/css/base.css" />
<style scoped>

</style>
